import React, { useRef , useEffect } from 'react';
import styles from './index.module.scss';
import { CheckCircleFill, ClockCircleFill } from 'antd-mobile-icons'

interface EPROInterviewItemProps {
    state: string;
    name: string;
    date: string;
    active: boolean;
    onSelect?: ({(): void})
}

const EPROInterviewItem = (props: EPROInterviewItemProps) => {
    const itemRef = useRef(null); 
    useEffect(() => {
      
        if (props.active && itemRef.current) {
            itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
        }
    }, [props.active]); //

 
    return (
        <div ref={itemRef} className={`${styles.eproInterviewItem} ${props.active ? styles.active : ''} ${props.state === 'Complete' ? styles.completed : ''}`} onClick={props.onSelect}>
            <div className={styles.name}>{props.name}</div>
            <div className={styles.date}>{props.date}</div>
            <div className={`${styles.state} ${props.state === 'Complete' ? styles.compeltedState : ''}  ${props.state === 'Running' ? styles.doingState : ''}`}>
                {props.state === 'Complete' ? <img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_visit_completed1701423018497.png'/> : ''}
                {props.state === 'Running' ? <img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_visit_doing1701423018497.png'/> : ''}
            </div>
        </div>
    )
}

export default EPROInterviewItem